import React, { useState , useEffect, useContext } from "react";
import Navbar from "./Navbar";
import ScrolltoTop from "./ScrolltoTop";
import '../azamara.css' ;
import Footer from "./Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar} from '@fortawesome/free-solid-svg-icons';
import AzamaraForm from "./AzamaraLeadForm";
import Deal from "./Deal";
import Azamara1 from "../assets/azamara1.jpg" ;
import Dealdata from "./Dealdata";
import { ReactComponent as Next } from '../assets/next.svg';
import { ReactComponent as Pre } from '../assets/pre.svg';
import WorldOwner from "../assets/world_owners_suite_living_room.jpg";
import SpaSuite from "../assets/spa_suite_living_room.jpg";
import OceanSuite from "../assets/ocean_suite_living_room.jpg";
import ContinentSuite from "../assets/continent_suite_living_room.jpg";
import Veranda from '../assets/veranda_plus.jpg';
import VerandaPlus from '../assets/veranda_balcony.jpg';
import Oceanview from "../assets/AZAoceanview.jpg";
import Interior from "../assets/AZA_interior.jpg";
import why1 from "../assets/onboard-yoga-fitness.jpg";
import why2 from "../assets/Onboard - Club Crooner.jpg";
import why3 from "../assets/Onboard_Dining_PrimeC_139.jpg";
import why4 from "../assets/Onboard_Dining_Windows.jpg";
import UtmUpdate from "./WhatsAppUTMLinkUpdater";
import { CurrencyContext } from "./CurrencyContext";


const dlink = {
  banner:{
    USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&Ship=15330&sortColumn=cruiselinePriority&sortOrder=asc",
    INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=8&destinationtype=All&Ship=15330&sortColumn=cruiselinePriority&sortOrder=asc"
  }
  
}


const Azamara =()=> {

  const Currency = useContext(CurrencyContext);

    
   const [rsindex, rssetIndex] = useState(0); // initial slide index

   const [rscardsPerView, rssetCardsPerView] = useState(2);
 
   // Array of only the selected deals
   const rsselectedDeals = [Dealdata[106], Dealdata[107], Dealdata[108] , Dealdata[109] , Dealdata[110] , Dealdata[111] , Dealdata[112] , Dealdata[113], Dealdata[114]];
 
   useEffect(() => {
       const rsupdateCardsPerView = () => {
         rssetCardsPerView(window.innerWidth < 768 ? 1 : 2);
       };
       rsupdateCardsPerView();
       window.addEventListener('resize', rsupdateCardsPerView);
       return () => window.removeEventListener('resize', rsupdateCardsPerView);
     }, []);
 
   const rsmaxIndex = rsselectedDeals.length - rscardsPerView;
 
   const rshandlePrev = () => {
     rssetIndex((prev) => (prev <= 0 ? rsmaxIndex : prev - 1));
   };
   
   const rshandleNext = () => {
     rssetIndex((prev) => (prev >= rsmaxIndex ? 0 : prev + 1));
   };
 
   const rsvisibleDeals = rsselectedDeals.slice(rsindex, rsindex + rscardsPerView);
 


  //  Asia Destination

    
   const [adindex, adsetIndex] = useState(0); // initial slide index

   const [adcardsPerView, adsetCardsPerView] = useState(2);
 
   // Array of only the selected deals
   const adselectedDeals = [Dealdata[117], Dealdata[123], Dealdata[124] ];
 
   useEffect(() => {
       const adupdateCardsPerView = () => {
         adsetCardsPerView(window.innerWidth < 768 ? 1 : 2);
       };
       adupdateCardsPerView();
       window.addEventListener('resize', adupdateCardsPerView);
       return () => window.removeEventListener('resize', adupdateCardsPerView);
     }, []);
 
   const admaxIndex = adselectedDeals.length - adcardsPerView;
 
   const adhandlePrev = () => {
     adsetIndex((prev) => (prev <= 0 ? admaxIndex : prev - 1));
   };
   
   const adhandleNext = () => {
     adsetIndex((prev) => (prev >= admaxIndex ? 0 : prev + 1));
   };
 
   const advisibleDeals = adselectedDeals.slice(adindex, adindex + adcardsPerView);
 


  // 
   
  const [eindex, esetIndex] = useState(0); // initial slide index

  const [ecardsPerView, esetCardsPerView] = useState(2);


  // Array of only the selected deals
  const eselectedDeals = [ Dealdata[115],Dealdata[116], Dealdata[119], Dealdata[120], Dealdata[121]];

  useEffect(() => {
    const eupdateCardsPerView = () => {
      esetCardsPerView(window.innerWidth < 768 ? 1 : 2);
    };
    eupdateCardsPerView();
    window.addEventListener('resize', eupdateCardsPerView);
    return () => window.removeEventListener('resize', eupdateCardsPerView);
  }, []);

  const emaxIndex = eselectedDeals.length - ecardsPerView;

  const ehandlePrev = () => {
    esetIndex((prev) => (prev <= 0 ? emaxIndex : prev - 1));
  };
  
  const ehandleNext = () => {
    esetIndex((prev) => (prev >= emaxIndex ? 0 : prev + 1));
  };

  const evisibleDeals = eselectedDeals.slice(eindex, eindex + ecardsPerView);



  const [ccindex, ccsetIndex] = useState(0); // initial slide index
  
   const [cccardsPerView, ccsetCardsPerView] = useState(2);

  // Array of only the selected deals
  const ccselectedDeals = [Dealdata[125], Dealdata[126], Dealdata[127], Dealdata[128] ];

  useEffect(() => {
    const ccupdateCardsPerView = () => {
      ccsetCardsPerView(window.innerWidth < 768 ? 1 : 2);
    };
    ccupdateCardsPerView();
    window.addEventListener('resize', ccupdateCardsPerView);
    return () => window.removeEventListener('resize', ccupdateCardsPerView);
  }, []);

  const ccmaxIndex = ccselectedDeals.length - cccardsPerView;

  const cchandlePrev = () => {
    ccsetIndex((prev) => (prev <= 0 ? ccmaxIndex : prev - 1));
  };
  
  const cchandleNext = () => {
    ccsetIndex((prev) => (prev >= ccmaxIndex ? 0 : prev + 1));
  };

  const ccvisibleDeals = ccselectedDeals.slice(ccindex, ccindex + cccardsPerView);


    return(

        <>

        <UtmUpdate/>
        
        <Navbar/>

        <div className="offer-alert azamara-alert" style={{marginTop:'100px'}}>
            <div>
                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
            </div>
             <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
         </div>

          <div class= "ajslider azamara-slider-main" >
            <div id="carouselExampleIndicators" class="carousel slide royal-header " data-bs-ride="carousel" data-bs-interval="3000">

           {/* <div className="royal-image">
            <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <img src={slide3} alt="Royal Caribbean" style={{cursor:'pointer'}}/></a>
            </div> */}

  <div class="carousel-indicators">
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
    <a href={dlink.banner[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
      <img src={Azamara1} class="d-block w-100" alt="..." style={{ height:'82vh'}}/>
    </a>
    </div>
    {/* <div class="carousel-item">
    <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer">
      <img src={RoyalBanner2} class="d-block w-100" alt="..." style={{ height:'82vh'}}/>
    </a>
    </div> */}
    {/* <div class="carousel-item">
      <img src={slide3} class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src={slide4} class="d-block w-100" alt="..."/>
    </div> */}
  </div>
  {/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button> */}
  </div>

<div className="Royalquote">
 <AzamaraForm /> 
 </div>
</div>

 <div className="azamara-maincontent">
            <p>Offering a deluxe style experience, Azamara is the perfect cruise line for travellers looking for unique, enriching
experiences. The fleet consists of 4 intimate, mid-sized ships that allow access to smaller ports and offer a personalized,
luxurious cruising experience. With longer visits on each port, more overnight stays and exclusive events guests don't just
visit their destination of choice but experience it.</p>
            <p>TIRUN represents Azamara as part of its portfolio of experiences covering all popular destinations including Asia,
Mediterranean, North Europe, South America and many more.</p>
        </div>



         <div className="royal-adventure"> 
            
            <div className="content">
            <h2>Europe Destination</h2>
            <p>Set sail on an unforgettable European adventure
with Azamara! Explore the sparkling
Mediterranean, charming villages of France, or
historic cities of Italy. Embark on an Adriatic
adventure, visit the Greek Isles, or discover the
beauty of Croatia. Feeling adventurous? Explore
Ireland or the majestic Baltic region. Azamara
has a European voyage to suit your every desire!</p>
            </div>
        {/* <div className="trip">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[5].img } Dealname={Dealdata[5].Dealname}  /></a>
        </div> */}

        <div className="carousel-wrapper" >
        <button onClick={rshandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {rsvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={rshandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        
        </div>
        </div>


        
         <div className="royal-adventure asia-destin"> 
            
            <div className="content">
            <h2>Asia Destination</h2>
            <p>Explore Asia with Azamara and enjoy the best of all worlds. From the vibrant cultures of India and Sri Lanka to the futuristic city of Singapore.
Discover the magic of Bali or experience the timeless culture and traditions of Japan. You will be delighted by each experience on your cruise to Asia - both onshore and offshore.</p>
            </div>
        {/* <div className="trip">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[5].img } Dealname={Dealdata[5].Dealname}  /></a>
        </div> */}

        <div className="carousel-wrapper" >
        <button onClick={adhandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {advisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={adhandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        
        </div>
        </div>


 <div className="royal-adventure celebrity-adventure"  style={{marginTop:'20vh'}}> 
            
            <div className="content">
            <h2>Other Popular
Destinations</h2>
            <p>Sail any corner of the world with Azamara cruises!  Head Down Under to Australia and New Zealand for natural wonders.
Relax on Caribbean beaches or journey through South America's lush rainforests. Explore the southern tip for the majestic landscapes of Cape Town, relax on Durban's golden beaches bathed in sunshine, or savor the beautiful climate of Mossel Bay.
For a taste of Western Africa, delve into St. Helena's rich history, immerse yourself in Dakar's vibrant culture, or marvel at Gran Canaria's landscapes.
And everywhere in between!</p>
            </div>

            <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={ehandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {evisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={ehandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        {/* <div className="trip">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[9].img } Dealname={Dealdata[9].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[10].img } Dealname={Dealdata[10].Dealname}  /></a>   
        </div> */}
        </div>
        </div>



<div className="royal-adventure azamara-adventure"> 
            
            <div className="content">
            <h2>Why Azamara Cruises</h2>
            <p>Set sail on an amazing discovery with
Azamara cruises! Explore hidden gems
aboard our intimate ships Azamara
Journey, Azamara Quest, Azamara Pursuit
and Azamara Onward, each carrying
about 700 guests residing in luxurious
ocean-view suites and staterooms that
provide a more personalised cruising
experience. See incredible sights, from
glaciers and islands to bustling cities and
historic shores. Explore destinations and
cultures deeper with local guides, enjoy
your evenings with live entertainment and
delicious food along with the option for
overnight stays at ports to explore even
more. With Azamara, your cruise will be
anything but ordinary!</p>
            </div>
        {/* <div className="ship">
          <img src={Celebrityship} alt="Royal Caribbean at Sea" />
        </div> */}

        {/* suit experience */}

                    {/* <div class= "Celebrity-suite-container"> */}
            <div id="carouselExampleIndicators2" class="carousel slide azamara-suite-carousel">


        <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>
  <div class="carousel-inner celebrity-suite-carousel">
    <div class="carousel-item active">
      <img src={why1} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={why2} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={why3} class="d-block w-100" alt="..." />
    </div>
    <div class="carousel-item">
      <img src={why4} class="d-block w-100" alt="..." />
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>
  {/* </div> */}

        </div>



  <div className="azamara-usp">
    <div>
        <h3>ALWAYS INCLUDED</h3>
       <ul>
        <li>Variety of Dining Venues & Room Service</li>
        <li>Beer, Wine, and Spirits All Day & Night</li>
        <li>Signature AzAmazing Evenings</li>
        <li>Unlimited Self-Service Laundry</li>
        <li>Tips & Gratuities</li>
       </ul>

    </div>
    <div>
        <h3>ALWAYS EXPECTED</h3>
         <ul>
        <li>Overnights & Extended Destination Days</li>
        <li>Unique & Iconic Destinations</li>
        <li>No Hassle, No Crowds</li>
        <li>Warm & Attentive Service</li>
       </ul>
    </div>
  </div>
        

<div className="royal-adventure"> 
            
            <div className="content">
            <h2>Azamara Suite &
Stateroom Experiences</h2>
            <p>Sail in comfort aboard Azamara's recently
revitalised ships. Your home away from home
provides stunning ocean views and private
verandas to soak the sea breeze . Whether you
pick a suite or stateroom you enjoy plush
European bedding, a flat screen TV, and wireless
internet throughout. Azamara offers more than
luxury with friendly, professional room service
which elevates every voyage. Just focus on having
fun while the rest is handled by Azamara cruises.</p>
            </div>
        {/* <div className="ship">
          <img src={Celebrityship} alt="Royal Caribbean at Sea" />
        </div> */}

        {/* suit experience */}

                    {/* <div class= "Celebrity-suite-container"> */}
            <div id="carouselExampleIndicators3" class="carousel slide azamara-suite-carousel">


        <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>
  <div class="carousel-inner celebrity-suite-carousel">
    <div class="carousel-item active">
      <img src={WorldOwner} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={SpaSuite} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={OceanSuite} class="d-block w-100" alt="..." />
    </div>
    <div class="carousel-item">
      <img src={ContinentSuite} class="d-block w-100" alt="..." />
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>
  {/* </div> */}

        </div>



        
 <div className="Cabin-container Laptop-res-accom" >

            <h2>ACCOMODATION</h2>

            <div className="Cabin">
            <div className="royal-cabin">
                
                <div className="cabin-category">  
                <div id="carouselExampleIndicators3" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
{/* <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Interior} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Veranda2} class="d-block w-100" alt="..."  />
</div> */}
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                INTERIOR
                </div>
                
                {/* <img src={Infinite} alt="Royal Caribbean Accomodation" />
                <div className="category-name" style={{textAlign:'center'}}>
                    VERANDA CABIN
                </div> */}
                </div>

                <div className="cabin-category">  
                <div id="carouselExampleIndicators4" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
{/* <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Oceanview} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={SkySuite2} class="d-block w-100" alt="..."  />
</div> */}
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
               OCEAN VIEW
                </div>
                {/* <img src={SkySuite} alt="Royal Caribbean Accomodation" />
                <div className="category-name">
                   SKY SUITE
                </div> */}
                </div>
            </div>

            <div className="royal-cabin">

            <div className="cabin-category">  
            <div id="carouselExampleIndicators5" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
{/* <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Veranda} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Edgevilla2} class="d-block w-100" alt="..."  />
</div>
 <div class="carousel-item">
<img src={Edgevilla3} class="d-block w-100" alt="..." />
</div>  */}
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div>  */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                VERANDA
                </div>
                {/* <img src={Edgevilla} alt="Royal Caribbean Accomodation" />
                <div className="category-name">
                EDGE VILLA
                </div> */}
                </div>

                <div className="cabin-category"> 
                <div id="carouselExampleIndicators6" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
{/* <button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={VerandaPlus} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Penthouse2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Penthouse3} class="d-block w-100" alt="..." />
</div> */}
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div>  */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                VERANDA PLUS
                </div> 
                {/* <img src={Penthouse} alt="Royal Caribbean Accomodation" />
                <div className="category-name">
                PENTHOUSE SUITE
                </div> */}

                </div>


            </div>

            </div>
            
        </div>




{/* Mobile Accomodation */}

        <div className="Cabin-container-mobile mobile-res-accom" >

<h2>ACCOMODATION</h2>

<div className="Cabin-mobile">
<div className="royal-cabin-mobile">
    
    <div className="cabin-category-mobile">  
    <div className="cabin-category mobile-responsive-royal-category">  

<div id="carouselExampleIndicators7" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
{/* <button type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Interior} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Veranda2} class="d-block w-100" alt="..."  />
</div> */}
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
{/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
<div className="category-name">
    INTERIOR
</div>
</div>
    {/* <img src={Infinite} alt="Royal Caribbean Accomodation" />
    <div className="category-name-mobile" style={{textAlign:'center'}}>
        VERANDA CABIN
    </div> */}
    </div>


    <div className="cabin-category mobile-responsive-royal-category"> 
                <div id="carouselExampleIndicators8" class="carousel slide ">


<div class="carousel-indicators">
{/* <button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={Oceanview} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={SkySuite2} class="d-block w-100" alt="..."  />
</div> */}
 {/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div> */}
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div>  */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div> 
                {/* <img src={Ocean} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   OCEAN VIEW
                </div>
                </div>
    {/* <div className="cabin-category-mobile">  
    <img src={SkySuite} alt="Royal Caribbean Accomodation" />
    <div className="category-name-mobile" style={{textAlign:'center'}}>
       SKY SUITE
    </div>
    </div> */}
</div>

<div className="royal-cabin-mobile">

<div className="cabin-category-mobile"> 
<div className="cabin-category mobile-responsive-royal-category">  
            <div id="carouselExampleIndicators9" class="carousel slide ">


<div class="carousel-indicators">
{/* <button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active">
<img src={Veranda} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Edgevilla2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Edgevilla3} class="d-block w-100" alt="..." />
</div> */}
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Balcony} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   VERANDA
                </div>
                </div> 
    {/* <img src={Edgevilla} alt="Royal Caribbean Accomodation" />
    <div className="category-name-mobile" style={{textAlign:'center'}}>
    EDGE VILLA
    </div> */}
    </div>

    <div className="cabin-category-mobile"> 
    <div className="cabin-category mobile-responsive-royal-category">  
            <div id="carouselExampleIndicators10" class="carousel slide ">


<div class="carousel-indicators">
{/* <button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="1" aria-label="Slide 2"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active">
<img src={VerandaPlus} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={Penthouse2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Penthouse3} class="d-block w-100" alt="..." />
</div> */}
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>
                {/* <img src={Balcony} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   VERANDA PLUS
                </div>
                </div> 
    {/* <img src={Penthouse} alt="Royal Caribbean Accomodation" />
    <div className="category-name-mobile" style={{textAlign:'center'}}>
    PENTHOUSE SUITE
    </div> */}

    </div>


</div>

</div>

</div>

        <div className="royal-adventure cc-cruises"> 
            
            <div className="content">
            {/* <p>Luxury Resorts at Sea</p> */}
            <h2>Azamara Fleet</h2>
            <p>Azamara cruises offer amazing adventures for
all types of travellers. Our smaller ships are
perfect for exploring hidden gems and getting
closer to the cultures you visit. They can handle
big oceans, navigate peaceful rivers, gracefully
traverse picturesque sceneries and reach ports
hidden from larger vessels . Imagine discovering
secret hideaways and fascinating cultures
cocooned in luxurious comfort!</p>
            </div>

            <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={cchandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {ccvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={cchandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
       

        {/* <div className="trip" style={{marginBottom:'40vh'}}>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer">  <Deal img={Dealdata[11].img } Dealname={Dealdata[11].Dealname}  /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[12].img } Dealname={Dealdata[12].Dealname}  /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[1].img } Dealname={Dealdata[1].Dealname}  /></a> */}

        {/* </div> */}

        </div>

        </div>


        <ScrolltoTop/>
        <Footer/>

        </>

    );
}

export default Azamara ;